import React, { useEffect } from "react";
import { Container, Row, Col, Breadcrumb } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { ChannelTable } from "./partials/ChannelTable";

export default () => {
  useEffect(() => {
    document.title = "Danh sách kênh";
  }, []);

  const regions = [
    { code: 'MN', name: 'Miền Nam' },
    { code: 'MT', name: 'Miền Trung' },
    { code: 'MB', name: 'Miền Bắc' },
  ];

  return (
    <Container fluid>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Kiến thiết</Breadcrumb.Item>
            <Breadcrumb.Item active>Danh sách kênh</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Danh sách kênh</h4>
        </div>
      </div>

      <Row>
        {regions.map((region) => (
          <Col xs={12} className="mb-4" key={region.code}>
            <div className="d-flex align-items-center justify-content-between mb-2">
               <h5 className="mb-0 text-primary fw-bold text-uppercase border-start border-4 border-primary ps-2">
                 {region.name}
               </h5>
            </div>
            <ChannelTable region={region.code} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};
